import { getState } from 'lib/store'

/**
 * Get selected attribute code from UI state
 */
export const getSelectedAttributeCode = (): string | null =>
  getState().search.ui.selectedAttributeCode

/**
 * Get manual search timestamp (ISO string)
 */
export const getManualSearchAt = (): string | null =>
  getState().search.ui.manualSearchAt
